export default [
    { value: true, text: "Ativo", variante: "success" },
    { value: false, text: "Inativo", variante: "danger" },
]